import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcTypography } from '@one/react';

export type PocTypographyProps = ComponentPropsWithoutRef<typeof OwcTypography>;

export const PocTypography = forwardRef<ElementRef<typeof OwcTypography>, PocTypographyProps>((props, ref) => (
    <OwcTypography ref={ref} {...props} />
));

PocTypography.displayName = 'PocTypography';
